module.exports = __webpack_public_path__ + "static/media/lightbulb-on.df42565d.svg";